import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import {
  Box,
  Typography,
  Tooltip,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Grid,
} from '@mui/material';
import { useSnackBar } from '../../../FlowBuilder/Common/SnackBar/index.tsx';
import SettingsIcon from '@mui/icons-material/Settings';
import { MaterialReactTable, MRT_ColumnDef, MRT_SortingState } from 'material-react-table';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useRecoilState, useRecoilValue } from 'recoil';
import { callStatusListAtom, userInformationAtom } from '../../../../Services/_states';
import { TemplateActions } from '../../../../Services/_actions/Template/template.actions';
import { dateFormate, indianTimeZone } from '../../../../utils/helper';
import SearchBox from '../../../FlowBuilder/Common/SearchBox/index.tsx';
import SelectDropdown from '../../../Shared/SelectDropdown';
import SearchableDropdown from '../../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { ConstantActions } from '../../../../Services/_actions';
import Pagination from '../../../FlowBuilder/Common/Pagination/index.tsx';
import { CallingModal } from '../../../Modals/CallingModal/CallingModal.jsx';
import ModalForms from '../../../Shared/Modals/index.js';
import FilterDrawer from '../../../Shared/FilterDrawer/index.tsx';
import Breadcrumb from '../../../Shared/Breadcrumb/index.tsx';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import DynamicBreadcrumbs from '../../../Shared/Breadcrumb/index.tsx';
import HomeIcon from '@mui/icons-material/Home';
import { TemplateUser } from '../../../../interfaces/Template.interface.ts';
import CommonTable from '../../../Shared/Tables/TableV1.tsx';
import CommentBox from '../../../Shared/CommentBox/index.tsx';
import LongStringView from '../../../Shared/LongStringView/index.tsx';
import { globalpermissions } from '../../../../Services/Permission.js';

interface Option {
  value?: string | any;
  label: string;
}
interface TemplateUserSummary {
  users: TemplateUser[];
  total_count: number;
}

const TemplateUsersV1: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // const [open, setOpen] = useState(false);
  const loggedInUser: any = useRecoilValue(userInformationAtom);
  const open = Boolean(anchorEl);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const { templateName, templateId, templateSentDate } = useParams();
  const [callStatusList, setCallStatusList] = useRecoilState(callStatusListAtom);
  const [selectedValues, setSelectedValues] = useState<Option | Option[] | null>(null);
  const navigate = useNavigate();
  const actions = TemplateActions();
  const { showSnackBar } = useSnackBar()
  const constActions = ConstantActions();
  const [filterObj, setFilterObj] = useState({
    templateId: '',
    sentDate: '',
    page: 0,
    search: "",
    status: "",
    assigned_to: "",
    sortField: "total_users",
    sortOrder: "desc",
    template_status: "",
    limit: 10
  })
  const [isLoading, setIsLoading] = useState(false);
  // const [templateUsersObj, setTemplateUsersObj] = useState({});
  const [templateUsersObj, setTemplateUsersObj] = useState<TemplateUserSummary>({
    users: [],
    total_count: 0,
  });
  const [modalShowCall, setModalShowCall] = useState(false);
  // const [actionRow, setActionRow] = useState({});
  const [actionRow, setActionRow] = useState<TemplateUser | any>(null);

  const [showFilter, setShowFilter] = useState(false);
  const [selectValues, setSelectValues] = useState(null);
  const statusOptions = [
    { label: 'New Message Sent', value: 'new message sent' },
    { label: 'Delivered', value: 'delivered' },
    { label: 'Read', value: 'read' },
    { label: 'Failed', value: 'failed' },
  ];
  const getTemplateUserSummary = async (data) => {
    setIsLoading(true);
    setTemplateUsersObj({ ...templateUsersObj, users: [] });
    console.log('Sending request with filterObj:', filterObj);
    let res = await actions.getTemplateUserSummary(data);
    console.log('API response:', res);
    setTemplateUsersObj(res);
    setIsLoading(false);
  }
  const clearFilters = () => {
    let obj = {
      ...filterObj,
      page: 1,
      search: "",
      status: "",
      assigned_to: "",
      sortField: "total_users",
      sortOrder: "desc",
      template_status: "",
      limit: 20
    }
    setFilterObj(obj);
    getTemplateUserSummary(obj);
  }
  const getCallStatusList = async () => {
    if (callStatusList.length > 0) return 0;
    let res = await constActions.getMachadaloStatusList({ dashboard: 'Template Dashboard' });
    setCallStatusList(res?.client_status || [])
  }
  const breadcrumbsData = [
    { label: <IconButton color='primary'><HomeIcon /></IconButton>, href: '/' },
    { label: 'Template List', href: '/r/whatsapp/template-list' },
    { label: 'Template Details', href: '#', onClick: (event) => { navigate(-1) }, },
    { label: 'User Template' },
  ];
  const handleTableChange = (type, { sortField, sortOrder, data }) => {
    if (type === 'sort') {
      if (sortField !== filterObj?.sortField || sortOrder !== filterObj?.sortOrder) {
        setFilterObj({ ...filterObj, sortField: sortField, sortOrder: sortOrder });
        getTemplateUserSummary({ ...filterObj, sortField: sortField, sortOrder: sortOrder });
      }
    }
  }

  const handleChangePage = (event, newPage) => {
    getTemplateUserSummary({ ...filterObj, page: newPage });
    setFilterObj({ ...filterObj, page: newPage });
  };
  const handleChangeRowsPerPage = (event) => {
    const value = parseInt(event.target.value, 10) || 10;
    getTemplateUserSummary({
      ...filterObj,
      limit: value,
      page: 0
    });
    setFilterObj({
      ...filterObj,
      limit: value,
      page: 0
    });
  };

  const onSearch = (e) => {
    setFilterObj({ ...filterObj, search: e, page: 1 });
    if (e.length > 2 || !e)
      getTemplateUserSummary({ ...filterObj, search: e, page: 1 });
  }
  const handleSelectStatus = async (e, i) => {
    let arr = [...templateUsersObj?.users];
    if (e) {
      arr[i] = { ...arr[i], last_call_status: e?.alais_name };
    } else {
      arr[i] = { ...arr[i], last_call_status: null };
    }
    await actions.updateTemplateCallStatus(arr[i]);
    setTemplateUsersObj((prevState) => ({
      ...prevState,
      users: arr,
    }));
    showSnackBar("Call status updated successfully", "success");
  }
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, row: TemplateUser) => {
    setAnchorEl(event.currentTarget);
    setActionRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleActionClick = (action: string, row: TemplateUser) => {
    setAnchorEl(null);
    setTimeout(() => {
      switch (action) {
        case 'Call & Comments':
          setModalShowCall(true);
          break;
        case 'B2B Form':
          navigate(`/r/ops-verify/${row.phone_number}`);
          break;
        case 'B2b2c Form':
          navigate(`/r/lead-web-form/${row.phone_number}`);
          break;
        default:
          break;
      }
    }, 100);
  };
  const handleDropdownChange = (selected: Option | Option[] | null) => {
    setSelectedValues(selected);
    // if (selected) {
    //   const updatedFilterObj = {
    //     ...filterObj,
    //     status: selected.value,
    //     page: 1,
    //   };
    const updatedFilterObj = {
      ...filterObj,
      status: selected ? selected.value : '',
      page: 1,
    };
    setFilterObj(updatedFilterObj);
    getTemplateUserSummary(updatedFilterObj);
    // }
  };
  const onSubmitComment = async (comment) => {
    let data = {
      "template_id": templateId,
      "sent_date": templateSentDate,
      "phone_number": actionRow?.phone_number,
      "gsid": actionRow?.gsid,
      "comment": comment,
    }
    let res = await actions.postTemplateUserComment(data);
    if (res?.status) {
      let rowData: { comments?: any } = { ...actionRow };
      rowData.comments = [...rowData?.comments, { comment_by: loggedInUser?.username, "comment": comment, comcreated_at: new Date() }];
      setActionRow(rowData);
    }
  }
  const clearFilter = () => {
    setSelectedValues(null);
    setSelectValues(null);
    const updatedFilterObj = {
      ...filterObj,
      status: '',
      template_status: '',
      page: 1,
    };
    setFilterObj(updatedFilterObj);
    getTemplateUserSummary(updatedFilterObj);
  };

  useEffect(() => {
    setFilterObj({ ...filterObj, templateId: templateId, sentDate: templateSentDate });
    getTemplateUserSummary({ ...filterObj, templateId: templateId, sentDate: templateSentDate });
    getCallStatusList();
  }, []);

  useEffect(() => {
    if (sorting?.length > 0) {
      const { id, desc } = sorting[0];
      const updatedFilters = {
        ...filterObj,
        sortField: id || 'created_at',
        sortOrder: desc ? 'desc' : 'asc',
      };
      setFilterObj(updatedFilters);
      getTemplateUserSummary(updatedFilters);
    }
  }, [sorting]);


  const columns: MRT_ColumnDef<TemplateUser>[] = [
    {
      accessorKey: 'index',
      header: 'S.No.',
      size: 100,
      enableSorting: false,
      Cell: ({ row }) => filterObj.page * filterObj.limit + row.index + 1,
    },
    {
      accessorKey: 'user_name',
      header: 'User Name',
      size: 150,
    },
    {
      accessorKey: 'whatsapp_name',
      header: 'WhatsApp Name',
      size: 150,
    },
    {
      accessorKey: 'phone_number',
      header: 'Phone Number',
      size: 150,
    },
    {
      accessorKey: 'button_count_1',
      header: 'B1',
      size: 50,
    },
    {
      accessorKey: 'button_count_2',
      header: 'B2',
      size: 50,
    },
    {
      accessorKey: 'button_count_3',
      header: 'B3',
      size: 50,
    },
    {
      accessorKey: 'status',
      header: 'Status',
      size: 100,
    },
    {
      accessorKey: 'updated_at',
      header: 'Updated At',
      size: 150,
      Cell: ({ cell }: any) => dateFormate(indianTimeZone(cell.getValue()), 'DD-MM-YYYY hh:mm A'),
    },
    {
      accessorKey: 'last_call_status',
      header: 'Call Status',
      size: 200,
      Cell: ({ cell, row }) => (
        <Box style={{ width: '200px' }}>
          <SearchableDropdown
            options={callStatusList}
            getOptionLabel={(option) => option?.alais_name || ''}
            value={cell.getValue() ? { alais_name: cell.getValue() } : null}
            onChange={(newValue) => handleSelectStatus(newValue, row.index)}
          />
        </Box>
      ),
    },
    {
      accessorKey: 'assigned_to',
      header: 'Assigned To',
      size: 150,
    },
    {
      accessorKey: 'comments',
      header: 'Comments',
      enableSorting: false,
      size: 200,
      Cell: ({ row }) => {
        const lastComment = row.original.comments?.at(-1)?.comment;

        return (
          <Typography variant="body2">
            {lastComment ? <LongStringView longString={lastComment} /> : 'No comments'}
          </Typography>
        );
      },
    },
    {
      accessorKey: 'actionView',
      header: 'Action',
      enableSorting: false,
      size: 100,
      Cell: ({ row }) => (
        <div>
          <IconButton
            color="primary"
            onClick={(e) => handleClick(e, row.original)}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            PaperProps={{
              sx: {
                boxShadow: 'none !important',
              },
            }}
          >

            <MenuItem onClick={() => handleActionClick('Call & Comments', row.original)}>
              Call & Comments
            </MenuItem>
            {constActions.userHasPermission([
              globalpermissions?.pagePermissions?.b2bFormPageAccess,
            ]) && (
                <MenuItem onClick={() => handleActionClick('B2B Form', row.original)}>
                  B2B Form
                </MenuItem>
              )}
            <MenuItem onClick={() => handleActionClick('B2b2c Form', row.original)}>
              B2b2c Form
            </MenuItem>
          </Menu>
        </div>
      ),
      enablePinning: true,
      muiTableHeadCellProps: {
        sx: {
          backgroundImage: 'linear-gradient(0deg, #3e59e3 35%, #5f76e8 100%)',
          color: 'white',
          fontWeight: '600',
          fontSize: '14px',
          fontFamily: 'system-ui',
          paddingLeft: '20px !important', // header padding here
        },
      },
      muiTableBodyCellProps: {
        sx: {
          backgroundColor: '#fafafa',
          paddingLeft: '20px !important',
        },
      },
    },

  ];
  const handleSearch = (searchText: string) => {
    console.log('Search text:', searchText);
  };
  const handleStatusDropdownChange = (selected: Option | Option[] | null) => {
    setSelectValues(selected);
    const updatedFilterObj = {
      ...filterObj,
      template_status: selected ? selected.value : '',
      page: 1,
    };
    console.log('Updated filter object:', updatedFilterObj);
    setFilterObj(updatedFilterObj);
    getTemplateUserSummary(updatedFilterObj);
  };


  return (
    <Box sx={{ padding: '5px', backgroundColor: '#f8f9fa', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
      <DynamicBreadcrumbs items={breadcrumbsData} onBreadcrumbClick={(event, item: { label: string, href: string }) => {
        if (item) {
          navigate(item?.href);
        }
      }}
      />
      <Grid container spacing={2} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Grid item sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, mb: 1 }}>
          <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>
            {`Template Users of ${templateName} Template (${templateSentDate})`}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={0} sx={{ alignItems: 'center', padding: '8px 0px' }}>
        <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'center', pb: 1 }}>
          {/* <IconButton
            onClick={() => setShowFilter(true)}
          >
            <FilterListIcon />
          </IconButton> */}
          <SearchBox handleSearch={onSearch} value={filterObj?.search || ''} />
        </Grid>
        <Grid item xs={12} md={8} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1, gap: { xs: "10px", sm: 2 }, width: { xs: '100%', sm: 'auto' }, flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
          <SearchableDropdown
            size="small"
            options={statusOptions}
            value={selectValues}
            onChange={handleStatusDropdownChange}
            label="Select Template Status"
            multiSelect={false}
            loading={false}
            error={false}
            errorMessage="Please select a valid option"
            onSearch={handleSearch}
            getOptionLabel={(option) => option.label}
            className="status-dropdown-style"
            sx={{
              maxWidth: 'auto',
              '& .MuiInputBase-root': {
                height: '28px',
              },
            }}
          />
          <SearchableDropdown
            size="small"
            options={callStatusList.map((item: any) => ({
              value: item.status_name,
              label: item.status_name,
            }))}
            value={selectedValues}
            onChange={handleDropdownChange}
            label="Select Call Status"
            multiSelect={false}
            loading={false}
            error={false}
            errorMessage="Please select a valid option"
            onSearch={(searchText) => console.log('Search text:', searchText)}
            getOptionLabel={(option) => option.label}
            // sx={{ minWidth: 150 }}
            className="status-dropdown-style"
            sx={{
              maxWidth: 'auto',
              '& .MuiInputBase-root': {
                height: '28px',
              },
            }}
          />

          <Button
            sx={{ width: '20%', height: '28px' }}
            variant="outlined"
            color="secondary"
            onClick={clearFilter}
          >
            Clear
          </Button>
        </Grid>

      </Grid>

      <CommonTable
        columns={columns}
        data={templateUsersObj?.users || []}
        muiTableContainerProps={{ sx: { maxHeight: 'calc(100vh - 355px)', width: '100%' } }}
        renderTopToolbar={false}
        state={{
          showColumnFilters: false,
          // pagination,
          sorting,
        }}
        enableStickyHeader={true}
        manualSorting={true}
        onSortingChange={setSorting}
        renderBottomToolbar={() => (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 0, margin: 0 }}>
            <Pagination
              totalCount={templateUsersObj?.total_count || 0}
              rowsPerPage={filterObj?.limit}
              page={filterObj?.page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Box>

        )}
      />
      {modalShowCall && (
        <ModalForms
          show={modalShowCall}
          // handleClose={(e) => {
          //   setModalShowCall(false);
          // }}
          handleClose={() => setModalShowCall(false)}
          modalBody={
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <CallingModal userDetails={actionRow} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CommentBox
                  commentList={actionRow?.comments || []}
                  onSubmitComment={onSubmitComment}
                // onRemoveComment={ }
                />
              </Grid>
            </Grid>
          }
          modalHeader={'Quick Call & Comments'}
          modalId={'calling_comments'}
          modalclassName={''}
          size="lg"
        />
      )}
      {/* <FilterDrawer
        open={showFilter}
        onClose={() => setShowFilter(false)}
        bodyData={
          <Box>
            <SearchableDropdown
              options={callStatusList.map((item: any) => ({
                value: item.status_name,
                label: item.status_name,
              }))}
              value={selectedValues}
              onChange={handleDropdownChange}
              label="Select Status"
              multiSelect={false}
              loading={false}
              error={false}
              errorMessage="Please select a valid option"
              onSearch={(searchText) => console.log('Search text:', searchText)}
              getOptionLabel={(option) => option.label}
            />

            <Grid item xs={2}>
              <Button
                sx={{ width: '50%', marginTop: 3 }}
                variant="outlined"
                color="secondary"
                onClick={clearFilter}
              >
                Clear
              </Button>
            </Grid>

          </Box>
        }
      /> */}
    </Box>
  );
};

export default TemplateUsersV1;
